import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

import useTranslations from '@/composables/useTranslations';
import { CwxBackend } from '@/types/cwxBackend';
import { computed } from 'vue';
import { BadgeContainer } from '@progress/kendo-vue-indicators';
import { useAppStore } from '@/stores/app.store';
import helpers from '@/helpers';

const inlineAvatarBorder = 2;

export default /*@__PURE__*/_defineComponent({
  __name: 'Avatar',
  props: {
    size: {},
    state: { default: 'normal' },
    avatarId: { default: undefined },
    showBadge: { type: Boolean, default: false },
    alt: { default: undefined }
  },
  setup(__props: any) {

const props = __props;

const appStore = useAppStore();
const { translate: t } = useTranslations();

const resolution = computed(() => {
  let currentSize;
  switch (props.size) {
    case 'xsmall':
      currentSize = 24;
      break;
    case 'small':
      currentSize = 40;
      break;
    case 'medium':
      currentSize = 60;
      break;
    case 'large':
      currentSize = 80;
      break;
    default:
      currentSize = 120;
      break;
  }
  return currentSize - inlineAvatarBorder;
});

const userAvatarImgUrl = computed((): string | undefined => {
  if (props.avatarId) {
    return helpers.url.outerUrl(
      `/images/${props.avatarId}/${resolution.value}x${resolution.value}/Profile.png`,
    );
  }

  return helpers.url.outerUrl(
    `/images/${CwxBackend.ImageType.Profile}/${resolution.value}x${resolution.value}/Profile.png`,
  );
});

const showStateBadge = computed(
  () => props.showBadge && props.state !== 'normal' && props.size !== 'xsmall',
);

const avatarContainerClass = computed(() =>
  showStateBadge.value ? `avatar-container--${props.state}` : null,
);

const avatarContainerProps = computed(() =>
  showStateBadge.value
    ? {
        rounded: 'full',
        align: {
          horizontal: appStore.dir === 'rtl' ? 'start' : 'end',
          vertical: 'bottom',
        },
      }
    : {},
);

const avatarSizeClass = computed(() =>
  props.size === 'extra large' ? 'avatar--xlarge' : `avatar--${props.size}`,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(showStateBadge.value ? _unref(BadgeContainer) : 'div'), _mergeProps({
    class: ["avatar-container", avatarContainerClass.value]
  }, avatarContainerProps.value), {
    default: _withCtx(() => [
      _createElementVNode("img", {
        class: _normalizeClass(["avatar", avatarSizeClass.value]),
        src: userAvatarImgUrl.value,
        alt: __props.alt ?? _unref(t)('Usr.Photo')
      }, null, 10, _hoisted_1)
    ]),
    _: 1
  }, 16, ["class"]))
}
}

})